import React from 'react';
import { FadeIn } from './FadeIn';
export const WhatYouGetSection = () => {
  const items = ['7 recetas completas de batidos (1 para cada día)', 'Checklist diario de ingredientes para no perder tiempo', 'Guía de instrucciones: cómo preparar cada batido paso a paso', 'Mini-guía de Ejercicios Exprés de 5 Minutos para complementar cada batido', "Bonus: Checklist de 'impulso rápido' por si necesitas repetir alguna receta en la semana"];
  return <section className="py-20 bg-darker" data-id="element-164">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-165">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-166">
          <FadeIn className="order-2 md:order-1 relative" data-id="element-167">
            <div className="absolute inset-0 bg-brand-orange rounded-2xl blur-3xl opacity-10" data-id="element-168"></div>
            <img src="https://cdn.magicpatterns.com/uploads/j1YbdKnEfcisX7v3WvYoXt/heylloyd-image-1776183147754.png" alt="Combinaciones de Jugos" className="relative rounded-2xl shadow-2xl border border-gray-800 w-full h-auto" data-id="element-169" />
          </FadeIn>
          <div className="order-1 md:order-2" data-id="element-170">
            <FadeIn data-id="element-171">
              <h2 className="font-serif text-3xl md:text-4xl font-bold mb-8 text-white" data-id="element-172">
                ¿Qué Incluye{' '}
                <span className="text-brand-orange" data-id="element-173">Tu Bundle?</span>
              </h2>
            </FadeIn>
            <div className="space-y-5" data-id="element-174">
              {items.map((item, index) => <FadeIn key={index} delay={0.2 + index * 0.1} data-id="element-175">
                  <div className="flex items-start" data-id="element-176">
                    <span className="text-xl mr-4 flex-shrink-0 mt-1" data-id="element-177">✅</span>
                    <p className="text-lg text-gray-300" data-id="element-178">{item}</p>
                  </div>
                </FadeIn>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
};